import { carrierLabel } from './carrierLabel';

export interface CarrierFilterChipsProps {
  carriers: string[];
  value: string[];
  onChange: (next: string[]) => void;
}

export function CarrierFilterChips({ carriers, value, onChange }: CarrierFilterChipsProps) {
  if (carriers.length === 0) return null;

  const selected = new Set(value);

  function toggle(carrier: string) {
    const next = new Set(selected);
    if (next.has(carrier)) {
      next.delete(carrier);
    } else {
      next.add(carrier);
    }
    onChange(Array.from(next));
  }

  return (
    <div className="flex flex-col gap-1">
      <span className="text-xs font-medium text-gray-700">
        {value.length === 0 ? 'All airlines' : 'Airlines'}
      </span>
      <div className="flex flex-wrap gap-2">
        {carriers.map((carrier) => {
          const { text, title } = carrierLabel(carrier);
          const isSelected = selected.has(carrier);
          return (
            <button
              key={carrier}
              type="button"
              aria-pressed={isSelected}
              title={title}
              onClick={() => toggle(carrier)}
              className={[
                'px-2 py-1 text-xs font-medium rounded-full border transition-colors',
                isSelected
                  ? 'bg-blue-600 text-white border-blue-600'
                  : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50',
              ].join(' ')}
            >
              {text}
            </button>
          );
        })}
      </div>
    </div>
  );
}
